import styled from '@emotion/styled';
import media from '@shared/mediaQuery';

const imageBreakpoint = 560;
const imageDesktopBreakpoint = `@media (min-width: ${imageBreakpoint + 1}px)`;
const imageMobileBreakpoint = `@media (max-width: ${imageBreakpoint}px)`;

const SolutionProductsStyle = styled('div')`
  .solutionproducts {
    &--header {
      ${media.mobile} {
        margin-left: 20px;
      }
      ${media.desktop} {
        display: flex;
      }
      &-title {
        font-size: 24px;
        color: #333333;
        &:after {
          font-family: 'Pretendard-Bold';
          content: '.';
          color: #ff5500;
          font-size: 24px;
        }
        ${media.mobile} {
          line-height: 32px;
        }
        ${media.desktop} {
          font-size: 28px;
          width: 273px;
          flex: none;
          margin-right: 50px;
          &:after {
            font-size: 28px;
          }
        }
        span {
          font-family: 'Pretendard-Bold';
        }
      }
      &-desc {
        color: #555555;
        ${media.mobile} {
          font-size: 14px;
          line-height: 22px;
          margin-top: 8px;
          width: calc(100% - 20px);
        }
        ${media.desktop} {
          font-size: 16px;
          line-height: 24px;
          width: 622px;
        }
      }
    }
    &--body {
      ${media.mobile} {
        margin-top: 32px;
      }
      ${media.desktop} {
        margin-top: 61px;
      }
    }
    &--products {
      display: flex;
      ${media.mobile} {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        padding-bottom: 10px;
      }
      ${media.desktop} {
        justify-content: space-between;
      }
    }
    &--product {
      ${media.mobile} {
        margin-right: 12px;
        &:first-of-type {
          margin-left: 20px;
        }
      }
      ${media.desktop} {
        width: 304px;
        flex: none;
      }
      &-header {
        display: flex;
      }
      &-ready {
        color: #999999;
        font-size: 13px;
        font-family: 'Nanum-Myeongjo-ExtraBold';
        margin-top: 13px;
        margin-left: 6px;
        ${media.desktop} {
          font-size: 16px;
          margin-top: 12px;
          margin-left: 5px;
        }
      }
      &-image {
        width: 156px;
        height: 186px;
        ${imageDesktopBreakpoint} {
          width: 304px;
          height: 181px;
        }
        &.desktop-image {
          ${imageMobileBreakpoint} {
            display: none;
          }
        }
        &.mobile-image {
          ${imageDesktopBreakpoint} {
            display: none;
          }
        }
      }
      &-title {
        font-family: 'Pretendard-Bold';
        font-size: 18px;
        color: #333333;
        margin-top: 7px;
        ${media.desktop} {
          margin-top: 5px;
          font-size: 20px;
        }
      }
      &-desc {
        font-size: 13px;
        color: #757575;
        line-height: 20px;
        ${media.desktop} {
          font-size: 15px;
          line-height: 24px;
          color: #555555;
          margin-top: 10px;
        }
        ${imageDesktopBreakpoint} {
          max-width: 304px;
        }
      }
      &-vacuum {
        width: 12px;
        flex: none;
      }
    }
  }
`;

export default SolutionProductsStyle;
